/**
     * @desc 接受报价
通过合约接受报价后，pending当前listing，pending当前bid
id：bid的id
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/acceptBid', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/acceptBid', params);
}
